import { render } from "./RoutesHub.vue?vue&type=template&id=7076a3a0&scoped=true"
import script from "./RoutesHub.vue?vue&type=script&lang=js"
export * from "./RoutesHub.vue?vue&type=script&lang=js"

import "./RoutesHub.vue?vue&type=style&index=0&id=7076a3a0&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7076a3a0"]])

export default __exports__